module.exports = __webpack_public_path__ + "static/img/03.66ab035.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/73/new/03.jpg
// module id = Hf/Q
// module chunks = 0